module.exports = __webpack_public_path__ + "img/arly-y.2459c3a4.svg";